/**
 * @desc 修改sku包装信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: Array<defs.basics.PlmSkuWarehousePackageRpcRequestDto>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/sku/updateSkuWarehousePackage`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
